import styled from "styled-components";
import { isTablet, isMobile } from "react-device-detect";

export const BonusWrapper = styled.div.attrs({})`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: start;
  align-items: auto;
  align-content: start;
`;

export const ActiveBonusColumn = styled.div`
  border-bottom: var(--activeBonusColumnBorderBottom, revert);
  padding: var(--activeBonusColumnPadding, revert);
  padding-bottom: var(--activeBonusColumnPaddingBottom, revert);
  width: 100%;
`;

export const BonusContainerLeft = styled.div`
  width: 80%;

  @media (max-width: 992px) {
    width: 100%;
  }
`;

export const BonusContainerRight = styled.div`
  width: 20%;
  margin: auto;

  @media (max-width: 992px) {
    width: 100%;
    text-align: center;
  }
`;

export const BonusImg = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  text-align: center;
  img {
    flex-grow: 0;
    width: 154px;
    height: 100%;
  }

  @media (max-width: 767px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const BonusDescriptionSection = styled.div`
  flex-grow: 2;
  padding: 1rem;
  div:first-child {
    padding-bottom: 0.5rem;
  }
`;

export const StyledRow = styled.div.attrs((props) => ({
  className: props.mt
    ? `row mt-3 ${props.mb}`
    : props.sort
      ? "row sort"
      : "row",
}))`
  background-color: ${({ validformWithdrawal }) =>
    !validformWithdrawal && "var(--styledRowBgColor, revert)"};
  border-radius: ${({ landing }) =>
    !landing && "var(--styledRowBorderRadius, revert)"};
  margin: ${({ landing, validformWithdrawal }) =>
    !landing && !validformWithdrawal && "var(--styledRowMargin, revert)"};
  color: var(--styledRowColor, revert);
  input {
    color: var(--styledRowInputColor, revert);
  }
  select {
    color: var(--styledRowSelectColor, revert);
  }
  .terms {
    text-align: ${isMobile ? "center" : "right"};
  }
`;

export const ActiveBonusSecondColumn = styled.div.attrs({
  className:
    "col-xs-12 col-md-8 col-lg-8 d-flex flex-column justify-content-between description my-3",
})``;

export const ActiveBonusTerms = styled.div`
  ol,
  ul {
    margin-left: 20px;
    list-style-position: outside;
  }
  li {
    display: list-item !important;
    padding: 5px 10px;
  }
  ol:before {
    font-size: 15px;
  }
`;

export const ActiveBonusActions = styled.div.attrs({
  className: "col-xs-12 col-md-12 col-lg-3",
})`
  margin-top: 6px;
  margin-bottom: -45px;

  .btn-first {
    height: 30px;
    width: 90px;
    padding: 0;
    font-size: 10px;
  }
`;

export const ActiveBonusContent = styled.div`
  width: ${isMobile ? "100%" : "20%"};
  img {
    width: 154px;
  }
`;
